/* unplugin-vue-components disabled */import { render } from "./itemlititle.vue?vue&type=template&id=32f3b238&scoped=true"
import script from "./itemlititle.vue?vue&type=script&lang=js"
export * from "./itemlititle.vue?vue&type=script&lang=js"

import "./itemlititle.vue?vue&type=style&index=0&id=32f3b238&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f3b238"]])

export default __exports__